var EVENT_TYPE = {
    MAIN_EVENT: 'mainEvent',
    MAIN_WL_EVENT: 'mainWLEvent',
    AD_EVENT: 'adEvent',
};
var EVENT_CATEGORIES = {
    MPL: 'Маркетплейс',
    LOAN: 'Подбор кредита',
    CREDIT_CARD: 'Подбор кредитной карты',
};

export { EVENT_CATEGORIES, EVENT_TYPE };
//# sourceMappingURL=constants.js.map
